import { createSlice } from "@reduxjs/toolkit";

type ExamDetails = {
  examCenterDetails: any;
  examRulesData: any;
  examLookupData: any;
};

const initialState: ExamDetails = {
  examCenterDetails: {},
  examRulesData: {},
  examLookupData: null,
};
const examDetails = createSlice({
  name: "examDetails",
  initialState,
  reducers: {
    setExamDetails: (state, action) => {
      state.examCenterDetails = action.payload.details;
    },
    setExamRulesData: (state, action) => {
      state.examRulesData = action.payload.details;
    },
    setLookupData: (state, action) => {
      state.examLookupData = action.payload.details;
    },
  },
});

export const { setExamDetails, setExamRulesData, setLookupData } =
  examDetails.actions;
export default examDetails.reducer;
